<template>
    <footer class="footer" style="clear: both;">
        <hr class="uk-grid-divider">
        <p class="uk-text-center uk-text-muted">© All rights reserved by REMCORP.</p>
        <!--<div v-if="isLogin">-->
            <!--<button class="button button&#45;&#45;link" @click="logout">-->
                <!--Logout-->
            <!--</button>-->
            <!--<RouterLink class="button button&#45;&#45;link" to="/invite">-->
                <!--ユーザーの招待-->
            <!--</RouterLink>-->
        <!--</div>-->
        <!--<RouterLink v-else class="button button&#45;&#45;link" to="/login">-->
            <!--Login / Register-->
        <!--</RouterLink>-->
    </footer>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { getCookieValue } from '../util'

export default {
    computed: {
        ...mapState({
            apiStatus: state => state.auth.apiStatus
        }),
        ...mapGetters({
            isLogin: 'auth/check'
        }),
        userInfo() {
            return this.$store.state.auth.user
        },
        messaging() {
            return this.$store.state.serviceWorker.messaging
        },
    },
    methods: {
        async logout () {
            await this.$store.dispatch('auth/logout')

            if (this.apiStatus) {
                this.$router.push('/login')
            }
        },
        // ServiceWorkerTokenをDBへ登録
        createServiceWorkerToken () {
            // ログイン時のみServiceWorkerTokenを登録するので、ログイン情報がなければreturn
            if (! this.userInfo) return

            this.$store.dispatch('serviceWorker/createServiceWorker')
            const messaging = this.messaging
            const serviceWorker = navigator.serviceWorker
            var userServiceWorkers = []

            userServiceWorkers = this.userInfo.service_workers
            serviceWorker.register('//' + window.location.host + '/js/serviceworker.js')
                .then((registration) => {
                    messaging.useServiceWorker(registration);

                    messaging.requestPermission().then(function() {
                        messaging.getToken().then(ServiceWorkerToken => {
                            if (userServiceWorkers.indexOf(ServiceWorkerToken) >= 0) return
                            // APIでServiceWorkerTokenをDBへ登録
                            axios.post('/api/service_worker/create', {
                                api_token: getCookieValue('token'),
                                service_worker_token: ServiceWorkerToken
                            })
                        });
                    }).catch(function(err) {
                        // 通知拒否
                    });

                    // registration.update();
                    registration.onupdatefound = function() {
                        console.log('Update for serviceworker.');
                        registration.update();
                    }
                });
        },
    },
    mounted() {
        this.createServiceWorkerToken()
    }
}

</script>

